import { RemoteObjectStore } from '@softline/core';
import { Zusatzartikel } from '../types/zusatzartikel';

export * as AuftragStore from './auftrag.store';
export * as StationStore from './station.store';
export const ZusatzartikelStore = RemoteObjectStore.create<Zusatzartikel[]>();
